module.exports = {
      id: "ic-omgusd-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dfad78.smartcharts.svg#ic-omgusd-usage",
      toString: function () {
        return this.url;
      }
    }